module.exports = __webpack_public_path__ + "media/images/logo-d357cb62.png";